import React from 'react';
import styles from './index.module.css';
import logo from 'images/quantastic_logo_big.svg';

const SplashScreen: React.FC = () => {
  return (
    <div className={styles.root}>
      <img className={styles.logo} src={logo} alt="logo" />
    </div>
  );
};

export default SplashScreen;
